import { useRef, useState } from 'react';
import Button from '@mui/material/Button';
import { useController } from 'react-hook-form';
import DocumentScannerIcon from '@mui/icons-material/DocumentScanner';
import { PdfAutoCompleteInput } from '../../../common/inputs/autoCompleteInputs/PdfAutoComplete';
import { PdfModal } from '../../../common/inputs/PdfAutoCompleteInput';
const AddScheduleHomeworks = (props: any) => {
    const i = useController({ name: props.source });
    const [createPdf, setCreatePdf] = useState(false);
    const isClearing = useRef(false);

    if (i.field.value && !props.multiple) {
        return (
            <div
                className={
                    'w-full p-4 rounded-md bg-gray-50 mb-4 border border-gray-200 flex justify-between items-center'
                }
            >
                <DocumentScannerIcon className={'text-black'} style={{ fontSize: '100px' }} />
                <Button
                    color={'error'}
                    onClick={() => {
                        i.field.onChange('');
                    }}
                >
                    Change Pdf
                </Button>
            </div>
        );
    }
    return (
        <div className={'w-full'}>
            {createPdf && (
                <PdfModal
                    title={props?.formData?.title || ''}
                    onClose={(e: any) => {
                        if (e) {
                            isClearing.current = false;
                            i.field.onChange(e);
                        }
                        setCreatePdf(false);
                    }}
                />
            )}
            <>
                <div className={'flex justify-between items-center'}>
                    <div className={'text-xs text-gray-500'}>Search By Name</div>
                    <div
                        onClick={() => {
                            setCreatePdf(true);
                        }}
                        className={
                            'text-indigo-500 text-sm font-medium py-1 cursor-pointer px-2 hover:bg-indigo-50 transition-all duration-200 rounded'
                        }
                    >
                        Add a New Pdf
                    </div>
                </div>
                <PdfAutoCompleteInput
                    source={props.source || 'pdfId'}
                    label={props.label || 'Pdf'}
                    multiple={props.multiple}
                />
            </>
        </div>
    );
};

export default AddScheduleHomeworks;
